import type { ViewIds } from '@ardoq/api-types';
import { LayoutExecutorAsyncWorker } from '@ardoq/yfiles';
import { workerApplyLayout } from './workerApplyLayout';

export const runMainThreadLayout = (
  viewId: ViewIds,
  data: object
): Promise<object> =>
  new LayoutExecutorAsyncWorker((graph, layoutDescriptor) =>
    workerApplyLayout(viewId, graph, layoutDescriptor)
  ).process(data);
